export default [
  { key: 'select', tdClass: 'text-center', thClass: 'col-nowrap' },
  {
    key: 'competencia',
    label: 'Competência',
    thClass: 'col-nowrap',
    sortable: true,
  },
  {
    key: 'consultadoEm',
    label: 'Consultado Em',
    thClass: 'col-nowrap',
    sortable: true,
  },
  {
    key: 'situacao',
    label: 'Paga',
    thClass: 'col-nowrap',
    sortable: true,
  },
]
